<template>
  <div>
    <el-dialog
      :title="$t('lang.添加设备')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form
        :model="deviceForm"
        ref="deviceFormRef"
        :rules="rules"
        :hide-required-asterisk="true"
        label-width="150px"
        :style="{ paddingLeft: $i18n.locale == 'zh-CN' ? '0px' : '30px' }"
      >
        <el-form-item :label="$t('lang.设备名称')" prop="meterName">
          <el-input
            v-model="deviceForm.meterName"
            :placeholder="$t('lang.请输入设备名称')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.资产号')" prop="meterNo">
          <el-input
            v-model="deviceForm.meterNo"
            :placeholder="$t('lang.请输入资产号')"
            @change="DeviceTypeQuery"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('lang.电价方案')"
          prop="priceId"
          v-if="deviceTypeShow == 0"
        >
          <el-select
            v-model="deviceForm.priceId"
            :placeholder="$t('lang.请选择电价方案')"
          >
            <el-option
              v-for="item in priceList"
              :key="item.priceId"
              :label="`${item.priceName} (${item.priceValue.toFixed(
                2
              )}${monetary}/kW·h)`"
              :value="item.priceId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('lang.水价方案')"
          prop="priceId"
          v-if="deviceTypeShow == 1"
        >
          <el-select
            v-model="deviceForm.priceId"
            :placeholder="$t('lang.请选择水价方案')"
            v-if="waterPriceList.length > 0"
          >
            <el-option
              v-for="item in waterPriceList"
              :key="item.priceId"
              :label="`${item.priceName} (${item.priceValue.toFixed(
                2
              )}${monetary}/m³)`"
              :value="item.priceId"
            ></el-option>
          </el-select>
          <el-link
            type="primary"
            :underline="false"
            v-if="!waterPriceList.length > 0"
            @click="operationPrice(1)"
            >{{ $t("lang.添加水价方案") }}</el-link
          >
        </el-form-item>
        <el-form-item :label="$t('lang.安装地址')" prop="address">
          <el-input
            v-model="deviceForm.address"
            :placeholder="$t('lang.请输入安装地址')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.租客姓名')" prop="tenantName">
          <el-input
            v-model="deviceForm.tenantName"
            :placeholder="$t('lang.请输入租客姓名')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('lang.联系电话')"
          class="contactNumber"
          prop="tenantPhone"
        >
          <MyPopover ref="myPopoverRef" />
          <el-input
            v-model="deviceForm.tenantPhone"
            :placeholder="$t('lang.请输入联系电话')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button
          type="primary"
          @click="onClickAddDevice"
          :loading="loading"
          >{{ $t("lang.保存") }}</el-button
        >
      </span>
    </el-dialog>
    <water-dialog ref="WaterDialogRef" />
  </div>
</template>

<script>
import MyPopover from "./my-popover.vue";
import { mapActions } from "vuex";
import WaterDialog from "../../personalSettings/price-control/dialog/water-dialog";
export default {
  components: { WaterDialog, MyPopover },
  data() {
    var meterNameRule = (rule, value, callback) => {
      let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
      if (reg.test(value)) {
        callback(new Error(this.$t("lang.不能有特殊字符")));
      } else if (value.trim() == "") {
        callback(new Error(this.$t("lang.请输入设备名称")));
      } else {
        callback();
      }
    };
    var tenantNameRule = (rule, value, callback) => {
      let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
      if (reg.test(value)) {
        callback(new Error(this.$t("lang.不能有特殊字符")));
      } else if (value == "") {
        callback(new Error(this.$t("lang.请输入租客姓名")));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        desc: "",
      },
      dialogVisible: false,
      deviceTypeShow: 0,
      priceList: [],
      waterPriceList: [],
      deviceForm: {
        meterName: "",
        meterNo: "",
        price: "",
        priceId: "",
        tenantAreaCode: "",
        address: "",
        tenantName: "",
        tenantPhone: "",
      },
      monetary: "元",
      rules: {
        meterName: [
          {
            required: true,
            validator: meterNameRule,
            trigger: "blur",
          },
        ],
        meterNo: [
          {
            required: true,
            message: this.$t("lang.请输入资产号"),
            trigger: "blur",
          },
        ],
        priceId: [
          {
            required: true,
            message: this.$t("lang.请选择电价方案"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("lang.请输入安装地址"),
            trigger: "blur",
          },
        ],
        tenantName: [
          {
            required: true,
            validator: tenantNameRule,
            trigger: "blur",
          },
        ],
        tenantPhone: [
          {
            required: true,
            message: this.$t("lang.请输入联系电话"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.monetary = localStorage.getItem("monetary");
  },
  methods: {
    ...mapActions({
      landlordEquipmentAdd: "ZD_LandlordEquipmentAdd",
      deviceBrowserMeterType: "ZD_DeviceBrowserMeterType",
      waterPricesList: "ZD_WaterPricesList",
      deviceWaterAdd: "ZD_DeviceWaterAdd",
    }),
    async DeviceTypeQuery() {
      let res = await this.deviceBrowserMeterType({
        meterno: this.deviceForm.meterNo,
      });
      if (res.success !== 1) return;
      this.deviceTypeShow = res.devicetype;
    },
    operationPrice(type, item) {
      this.$refs.WaterDialogRef.showDialog(type, item);
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.deviceFormRef.resetFields();
    },
    async getPriceList() {
      this.monetary = localStorage.getItem("monetary");
      let res = await this.waterPricesList({});
      if (res.success !== 1) return;
      this.waterPriceList = res.listitem;
    },
    async onClickAddDevice() {
      this.loading = true;
      let res = {};
      this.deviceForm.tenantAreaCode = this.$refs.myPopoverRef.selAreaCode;
      this.deviceForm.rootId = this.$parent.levelData.rootId;
      try {
        await this.$refs.deviceFormRef.validate();
        this.deviceForm.tenantName = this.deviceForm.tenantName.trim();
        switch (this.deviceTypeShow) {
          case 0:
            this.deviceForm.price = this.priceList.find(
              (item) => item.priceId == this.deviceForm.priceId
            ).priceValue;
            res = await this.landlordEquipmentAdd({
              value: this.deviceForm,
            });
            if (res.success !== 1) return;
            break;
          case 1:
            this.deviceForm.price = this.waterPriceList.find(
              (item) => item.priceId == this.deviceForm.priceId
            ).priceValue;
            res = await this.deviceWaterAdd({
              value: this.deviceForm,
            });
            if (res.success !== 1) return;
            break;
          default:
            break;
        }
        this.$message({
          message: this.$t("lang.添加成功"),
          type: "success",
        });
        this.handleClose();
        this.$parent.onClickQuery();
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog {
  width: 569px !important;
}
.el-input {
  width: 300px;
}
.el-select {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
}
.contactNumber {
  position: relative;
  /deep/.el-input__inner {
    padding-left: 55px;
  }
}
</style>
